<template>
  <span
      class="select-checkbox"
      role="checkbox"
      :aria-checked="indeterminate ? 'mixed' : String(value)"
      tabindex="0"
      @click.stop="toggle"
      @keydown.space.prevent="toggle"
      @keydown.enter.prevent="toggle"
  >
    <svg v-if="indeterminate" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="16" height="16" rx="3" ry="3" fill="#29ABE2" stroke="#29ABE2" stroke-width="1.5"/>
      <rect x="5" y="8" width="8" height="2" fill="#FFFFFF"/>
    </svg>
    <svg v-else-if="value" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="16" height="16" rx="3" ry="3" fill="#29ABE2" stroke="#29ABE2" stroke-width="1.5"/>
      <path d="M5 9.5l2.5 2.5L13 6.5" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg v-else width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="16" height="16" rx="3" ry="3" fill="#FFFFFF" stroke="#979797" stroke-width="1.5"/>
    </svg>
  </span>
</template>

<script>
export default {
  name: 'SelectCheckbox',
  props: {
    value: { type: Boolean, default: false },
    indeterminate: { type: Boolean, default: false }
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value);
    }
  }
};
</script>

<style scoped>
.select-checkbox {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  cursor: pointer;
  vertical-align: middle;
  user-select: none;
  outline: none;
}
.select-checkbox:focus-visible {
  box-shadow: 0 0 0 2px rgba(41, 171, 226, 0.5);
  border-radius: 4px;
}
.select-checkbox svg {
  display: block;
}
</style>
